import { useTagOptions } from "../../lib/hooks/basic/tags";
import { SelectField, type SelectFieldProps } from "../form/SelectField";

export function TagSelect(props: SelectFieldProps) {
  const { search, options } = useTagOptions();

  return (
    <SelectField
      allowClear
      mode="tags"
      onSearch={search}
      options={options.map((o) => ({
        label: o.label,
        key: o.label,
      }))}
      {...props}
    />
  );
}
